module.exports = __webpack_public_path__ + "static/img/image10.98fe7177.png";